import { UserRoutingStrategy, RoutingContext, NavigationDestination } from '../types';
import { User } from '@/services/platformApi';
import { getDefaultAuthenticatedDestination } from '@/utils/domainDetection';

/**
 * Fallback routing strategy - catches all users not handled by other strategies
 * This ensures every user gets routed somewhere
 */
export class FallbackRoutingStrategy implements UserRoutingStrategy {
  priority = -1; // Lowest priority - true fallback

  canHandle(user: User): boolean {
    // This strategy can handle any user (it's the ultimate fallback)
    return true;
  }

  async getDestination(context: RoutingContext): Promise<NavigationDestination> {
    const { user, returnUrl, fromSignup } = context;

    console.log('[FallbackRoutingStrategy] Handling user with roles:', user.roles);
    console.log('[FallbackRoutingStrategy] User has merchant profile:', !!user.otherProfiles?.merchant);

    // If there's a specific return URL, respect it
    if (returnUrl && this.isValidReturnUrl(returnUrl)) {
      return { path: returnUrl };
    }

    // For new signups, send to profile to complete setup
    if (fromSignup) {
      return {
        path: '/profile',
        state: { 
          fromSignup: true,
          showWelcome: true
        }
      };
    }

    return {
      path: getDefaultAuthenticatedDestination(),
      state: {
        fromLogin: context.fromLogin,
        userId: user._id,
      },
    };
  }

  private isValidReturnUrl(url: string): boolean {
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin;
    } catch {
      return url.startsWith('/') && !url.startsWith('//');
    }
  }
}
